import '.gn{position:sticky;}.ssr-plugin'
import '.aa{left:16px;}.ssr-plugin'
import '.jk{top:50%;}.ssr-plugin'
import '.b7{width:16px;}.ssr-plugin'
import '.v{transform:translateY(-50%);}.ssr-plugin'
import '.jl{height:8px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.bg{height:1px;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import React, { useEffect, useState } from 'react'
import { styled } from 'inlines'
import { Menu } from '../Menu/index.js'
import { colors } from '../../tokens/colors.js'
import { Text } from '../Text/index.js'
import { truncateString } from '../../utils/truncateString.js'

export const MiniNavigation = ({ value, scrollContainerRef }) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const orderedTitles = []
  let i = 0

  while (i < value?.length) {
    if (value[i] === '<') {
      let tagType = ''
      let tagStart = -1
      let tagEnd = -1

      if (
        value[i + 1] === 'h' &&
        (value[i + 2] === '1' || value[i + 2] === '2' || value[i + 2] === '3')
      ) {
        tagType = `h${value[i + 2]}`

        let j = i + 3
        while (j < value.length && value[j] !== '>') {
          j++
        }
        tagStart = j + 1

        let closingTag = `</${tagType}>`
        let k = tagStart
        while (k < value.length) {
          if (value.substring(k, k + closingTag.length) === closingTag) {
            tagEnd = k
            break
          }
          k++
        }

        if (tagEnd > tagStart) {
          let innerText = value.substring(tagStart, tagEnd)
          innerText = innerText.replace(/<[^>]*>/g, '')
          innerText = innerText.replace(/&nbsp;/g, ' ')
          innerText = innerText.replace(/&amp;/g, '&')
          innerText = innerText.replace(/&lt;/g, '<')
          innerText = innerText.replace(/&gt;/g, '>')
          innerText = innerText.replace(/&quot;/g, '"')
          innerText = innerText.replace(/&#39;/g, "'")
          innerText = innerText.trim()

          if (innerText) {
            orderedTitles.push({
              level: tagType,
              text: innerText,
            })
          }

          i = k + closingTag.length
        } else {
          i++
        }
      } else {
        i++
      }
    } else {
      i++
    }
  }

  useEffect(() => {
    if (!scrollContainerRef?.current || orderedTitles.length === 0) return

    const container = scrollContainerRef.current

    const handleScroll = () => {
      const editor = container.querySelector('.editor')
      if (!editor) return

      const headings = editor.querySelectorAll('h1, h2, h3')
      const containerRect = container.getBoundingClientRect()
      const containerMidpoint = containerRect.top + containerRect.height / 3

      let closestIndex = 0

      for (let idx = 0; idx < headings.length; idx++) {
        const heading = headings[idx]
        const headingRect = heading.getBoundingClientRect()
        const headingTop = headingRect.top

        // Check if heading is above the midpoint (has been scrolled past)
        if (headingTop <= containerMidpoint) {
          closestIndex = idx
        } else {
          // If we've found a heading below the midpoint, stop checking
          break
        }
      }

      setActiveIndex(closestIndex)
    }

    // Initial check
    handleScroll()

    // Add scroll listener
    container.addEventListener('scroll', handleScroll)

    return () => {
      container.removeEventListener('scroll', handleScroll)
    }
  }, [scrollContainerRef, value, orderedTitles.length])

  return (
    <styled.div className="gn aa jk b7 v"
      style={{
        '@media only screen and (max-width: 1080px)': {
          opacity: 0,
          pointerEvents: 'none',
        },
      }}
    >
      <Menu openOnHover>
        <Menu.Trigger>
          <styled.div>
            {orderedTitles.map((k, idx) => {
              return (
                <div className="jl a d"
                  key={idx}
                  style={{
                    width: activeIndex === idx ? 16 : 8,
                  }}
                >
                  <div className="bg f"
                    style={{
                      background:
                        activeIndex === idx
                          ? colors.neutral60
                          : colors.neutral20,
                    }}
                  />
                </div>
              )
            })}
          </styled.div>
        </Menu.Trigger>
        <Menu.Items
          style={{
            // marginTop: `-${typeSchemaObjectKeys.length * 8 + 16}px`,
            transform: 'translateY(-50%)',
          }}
        >
          <Text
            variant="subtext-medium"
            color="neutral60"
            style={{ padding: '2px 8px' }}
          >
            Table of contents
          </Text>
          {orderedTitles.map((item, idx) => {
            return (
              <Menu.Item
                key={idx}
                keepOpenOnClick
                onClick={() => {
                  if (scrollContainerRef?.current) {
                    const container = scrollContainerRef.current
                    const editor = container.querySelector('.editor')

                    if (editor) {
                      const headings = editor.querySelectorAll('h1, h2, h3')
                      const targetHeading = headings[idx]

                      if (targetHeading) {
                        const containerRect = container.getBoundingClientRect()
                        const headingRect =
                          targetHeading.getBoundingClientRect()
                        const scrollOffset =
                          headingRect.top -
                          containerRect.top +
                          container.scrollTop -
                          20

                        container.scrollTo({
                          top: scrollOffset,
                          behavior: 'smooth',
                        })
                      }
                    }
                  }
                }}
              >
                {truncateString(item.text, 36)}
              </Menu.Item>
            )
          })}
        </Menu.Items>
      </Menu>
    </styled.div>
  )
}
